import { Card } from '@ui/themed';
import { t } from 'i18next';
import { Upsell } from '../../../components/upsell';
import { useHandlers, useSite } from '../../../context/page-context';
import { trackUpgradeClicked } from '../../../lib/mixpanel';

export function APISettingsUpsell() {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  const FEATURE_ITEMS = [
    {
      key: 'pricing',
      title: t('features:api_settings.components.api_settings_upsell.features.pricing.title'),
      description: t(
        'features:api_settings.components.api_settings_upsell.features.pricing.description',
      ),
    },
    {
      key: 'integration',
      title: t('features:api_settings.components.api_settings_upsell.features.integration.title'),
      description: t(
        'features:api_settings.components.api_settings_upsell.features.integration.description',
      ),
    },
  ];

  return (
    <Card>
      <Upsell
        title={t('features:api_settings.components.api_settings_upsell.title')}
        subtitle={t('features:api_settings.components.api_settings_upsell.subtitle')}
        imageType={'settingsAPI'}
        plans={['v2_pro']}
        onClickUpgrade={() => {
          trackUpgradeClicked(site, 'API_ACCESS');
          navigationHandler.navigateById('plan');
        }}
        onClickLearn={() =>
          navigationHandler.navigate('https://docs.sparklayer.io/tech-docs', {
            absolute: true,
            newTab: true,
          })
        }
        details={{
          foreword: t('features:api_settings.components.api_settings_upsell.intro'),
          use_cases: FEATURE_ITEMS,
          afterword: t('features:api_settings.components.api_settings_upsell.disclaimer'),
          learnMoreURLText: t('features:api_settings.components.api_settings_upsell.learn_more'),
        }}
      />
    </Card>
  );
}
